import React, { useState, useRef, useEffect } from 'react';
import { Globe, Check, ChevronDown } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang, languages } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = languages.find((l) => l.code === lang) || languages[0];
  const sfx = compact ? '-mobile' : '';

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div className="relative" ref={ref} data-testid={`language-switcher${sfx}`}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1.5 p-2 rounded-full border border-border text-muted-foreground hover:text-primary hover:border-primary transition-all duration-300"
        title="Langue / Language"
        aria-label="Choisir la langue"
        data-testid={`language-switcher-button${sfx}`}
      >
        <Globe size={18} />
        {!compact && <span className="text-sm font-medium">{current.native}</span>}
        <ChevronDown size={14} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute right-0 rtl:left-0 rtl:right-auto mt-2 min-w-[160px] bg-popover text-popover-foreground border border-border rounded-md shadow-lg p-1 z-[60]" data-testid={`language-switcher-menu${sfx}`}>
          {languages.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center justify-between gap-3 px-3 py-2 rounded text-sm hover:bg-primary/5 ${l.code === lang ? 'text-primary font-semibold' : 'text-foreground'}`}
              data-testid={`language-option-${l.code}${sfx}`}
            >
              <span>{l.native}</span>
              {l.code === lang && <Check size={16} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
